import React from 'react';
import { NightsPicker } from '@lt/components';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import SearchParamsItem from './SearchParamsItem';
import SearchParamsLabel from './SearchParamsLabel';
import { pluralizeNights } from '../../../../../utils/pluralizeUtils';

import SearchParamsControl from './SearchParamsControl';

interface SearchParamsNightsProps {
  nights: number;
  onChangeNights: (value: number) => void;
  isMobile?: boolean;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsNights = ({
  isMobile,
  nights,
  onChangeNights,
  isHotelOnly,
  isArchived,
}: SearchParamsNightsProps) => {
  const { t } = useTranslation();

  const CustomControl = isMobile
    ? SearchParamsControlMobile
    : SearchParamsControl;
  const CustomLabel = () => (
    <SearchParamsLabel label={t('checkout.search.night')} />
  );

  return (
    <SearchParamsItem name="nights" border>
      <div className="like-h2">{`${nights} ${pluralizeNights(nights)}`}</div>

      {!isArchived && !isHotelOnly ? (
        <StyledWrapper>
          <NightsPicker
            nights={nights}
            showFlexNights={false}
            onChangeNights={onChangeNights}
            isMobile={isMobile}
            CustomControl={CustomControl}
            CustomLabel={CustomLabel}
          />
        </StyledWrapper>
      ) : null}
    </SearchParamsItem>
  );
};

const SearchParamsControlMobile = () => {
  const { t } = useTranslation();
  return <StyledButton>{t('checkout.search.night')}</StyledButton>;
};

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  color: #007aff;

  &:hover {
    cursor: pointer;
  }
`;

const StyledWrapper = styled.div`
  position: absolute;
  bottom: -20px;

  .react-select__control {
    height: 17px;
    min-height: 17px;
  }

  .react-select__value-container {
    padding-left: 0;
  }
`;

export default SearchParamsNights;
